export const logout = {
  title: 'You have successfully been logged out of the Cards Carbon Footprint.',
  text: `Thanks for taking a look at your carbon footprint. Together, we're a financial force for change.`,
  button: 'Back to Mashreq',
  url: 'https://www.mashreqbank.com/en/uae/personal/',
};
